"use client";

import { Avatar } from "@nextui-org/react";
import { Syncronization, ProgressCircle } from "@/app/author/(components)";
import useSyncStatus from "@/app/author/(hooks)/useSyncHook";

export default function AuthorPanel({
  authorsJoined = [],
  authorId,
  lastSynchronizationDate,
  isSyncing,
  setIsSyncing,
  setModalMessage,
  setModalIsOpen,
  setModalIsError,
}) {
  const { stopChecking, progressPropieties } = useSyncStatus(
    authorId,
    setIsSyncing,
    setModalMessage,
    setModalIsOpen,
    setModalIsError,
    isSyncing
  );
  return (
    <div className="flex flex-col w-full h-full shadow rounded-lg p-4 gap-4">
      {/* Autores Asociados */}
      <div className="w-full bg-white flex flex-col">
        <h2 className="text-xl font-bold mb-4 text-center">
          Autores Asociados
        </h2>

        {authorsJoined.length > 0 ? (
          <div className="flex flex-col gap-2 overflow-y-auto max-h-[40vh] pr-2 shrink-0">
            {authorsJoined.map((author) => (
              <div
                key={author.authorId}
                className="flex items-center space-x-4 p-4 border rounded-lg shadow-sm bg-gray-50"
              >
                <Avatar
                  src={author.image_1 || "/autoricon.png"}
                  className="w-12 h-12"
                  name={author.label}
                />
                <div className="w-full">
                  <span className="text-gray-700">{author.label}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center">No hay autores asociados.</p>
        )}
      </div>

      {/* Sincronización */}
      <Syncronization
        authorId={authorId}
        isSyncing={isSyncing}
        lastSynchronizationDate={lastSynchronizationDate}
        setIsSyncing={setIsSyncing}
        setModalMessage={setModalMessage}
        setModalIsOpen={setModalIsOpen}
        setModalIsError={setModalIsError}
      />

      {/* Círculo de progreso */}
      <ProgressCircle
        isSyncing={isSyncing}
        onBack={stopChecking}
        {...progressPropieties}
      />
    </div>
  );
}
